import gql from 'graphql-tag';

export default gql`
  mutation deliveryNoteDelete($id: ID!) {
    deliveryNoteDelete(id: $id) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
